import functions from "./functions.js";
import { Select2 } from "./components/select2";

$(() => {
    booking.init();
});

const booking = {
    $form: null,
    form: null,
    calc: [],
    totalAmount: null,
    params: {},

    init() {

        this.$form = $('.booking-form');
        this.form = this.$form[0];

        if (! this.$form.length) {
            return;
        }

        this.checkPaymentType();
        this.prepareForBooking();
        this.getGuestsData();

        if ( ! booking.calc.length) {
            return;
        }

        this.totlaGuests = 0;
        booking.calc.forEach(calcItem => {
            if (calcItem.itemDefinitionId.categoryId.key == 'baseRate'
                && [1,6].includes(calcItem.itemDefinitionId.objectGroupId.id)
            ) {
                let guests = calcItem.guests.split(',');
                this.totlaGuests = +guests[0] + +guests[1];
            }
        });

        this.$form.on('change', 'input[type="checkbox"], input[type="radio"]', function (e) {
            let $calcItem = $(e.currentTarget).closest('.calc-item');
            let $quantity = $calcItem.find('[name=quantity]');
            let value = $quantity.length ? +$quantity.val() : this.totlaGuests;
            let checked = $(e.currentTarget).is(':checked') ? 1 : 0;

            if ($quantity.length) {
                if (checked && !value) {
                    $quantity.prop('value', booking.totlaGuests);
                } else if (! checked && value) {
                    $quantity.prop('value', 0);
                }
                $quantity.trigger('change');
            }

            booking.calculate($(e.currentTarget));
        });

        $('[name=quantity]').on('change', e => {
            const $target = $(e.currentTarget);
            let value = +$target.val();
            let $calcItem = $target.closest('.calc-item');
            let $checkbox = $calcItem.find('input[type="checkbox"]');

            if (value && ! $checkbox.is(':checked')) {
                $checkbox.prop('checked', true);
            } else if (! value && $checkbox.is(':checked')) {
                $checkbox.prop('checked', false);
            }

            booking.calculate($(e.currentTarget));
        });

        booking.$payment = $('.payment-details');

        this.$form.on('submit', e => {
            //e.preventDefault();
            //e.stopPropagation();

            this.submit();
        });

        this.$form.on('change', e => {
            const $target = $(e.currentTarget);
            const data = functions.getFormData($target);

            let guestsData = {};

            const guestsDataKeys = [
                'guestFirstName',
                'guestLastName',
                'birthDateDay',
                'birthDateMonth',
                'birthDateYear',
                'gender',
            ];
            /*const holderDataKeys = [
                'firstName',
                'lastName',
                'email',
                'phone',
                'address',
            ];*/

            for (const [key, value] of Object.entries(data)) {
                // ako key starts with guestsDataKey, spremi u JSON za cookie guestsData
                let hasKey = guestsDataKeys.find(guestDataKey => {
                    return key.startsWith(guestDataKey);
                });
                if(hasKey) {
                    let calcIds = value.split(',');

                    calcIds.forEach((itemValue, calcId) => {
                        if(! guestsData[calcId]) guestsData[calcId] = {};
                        guestsData[calcId][key] = itemValue;
                    });
                    //guestsData[key] = value;
                }

                // ako je key == holderDataKey, spremi u JSON cookie holderData

            }
            
            //functions.setCookie('guestsData', null, -1);
            // cookie neka se cleara za tjedan dana
            functions.setCookie('guestsData', JSON.stringify(guestsData), 7);
        });

        const $partnerCodeSuccess = $(".partnerCodeSuccess");
        const $partnerCodeError = $(".partnerCodeError");

        if($('#partnerCodeApply').length) {
            $('#partnerCodeApply').on('click', function (e) {
                e.preventDefault();

                let params = functions.getUrlData(false);
                params.partnerCode = $("[name='partnerCode']").val();
                params.language = functions.getLang();

                $partnerCodeSuccess.addClass('d-none');
                $partnerCodeError.addClass('d-none');

                //$('button[type="submit"]').attr('disabled', 'disabled');

                $.get('/services/booking_form_cart/', $.param(params)).then(response => {
                    response = JSON.parse(response);
                    if (response.status) {
                        $('.cart-booking').replaceWith(response.html);
                        booking.prepareForBooking();
                        $partnerCodeSuccess.removeClass('d-none');
                        $partnerCodeError.addClass('d-none');
                    } else {
                        $partnerCodeSuccess.addClass('d-none');
                        $partnerCodeError.removeClass('d-none');
                    }

                    // LOZAD
                    window.observer.observe();

                    $(".select2:not([data-select2-id])").each((i, elem) => {
                        elem._select2 = new Select2(elem);
                    });

                    booking.getGuestsData();
                });
            });
        }

        // recalculate if guests birthDates are different than in initial calc

        let cart_data = functions.getUrlData(false);
        cart_data = JSON.parse(cart_data.cart_data);

        $('.booking-form').on('blur', '.guests input[name]', function (e) {

            const $guestsRow = $(e.currentTarget).closest('.guests');
            const calcId = $guestsRow.attr('data-guests-parentid');
            let calc = booking.calc.find((calc, i) => calc.calcId == calcId);
            if ( !calc ) {
                calc = cart_data[calcId-1];
            }

            const dateFrom = calc.dateFrom;
            const guests = (calc.guests || '').split(',');
            const adults = +guests[0];
            const children = +guests[1] || 0;
            const childrenAges = guests.slice(2, 2+ children).sort((a,b) => a < b ? 1 : -1);


            let _adults = 0;
            let _childrenAges = [];
            let guestInfo = [];
            $guestsRow.find('[data-guests]').map((i, elem) => {
                let $year = $guestsRow.find('input[name="birthDateYear' + i + '"]');
                let $month = $guestsRow.find('input[name="birthDateMonth' + i + '"]');
                let $day = $guestsRow.find('input[name="birthDateDay' + i + '"]');

                let year = (+$year.val() || '') + '';
                let month = (+$month.val() || '') + '';
                let day = (+$day.val() || '') + '';

                if ( year && month && day ) {

                    if ( year.length !== 4 || year < 1925) {
                        $year.addClass('is-invalid');
                    } else {
                        $year.removeClass('is-invalid');
                    }

                    if ( month > 12 || month < 1) {
                        $month.addClass('is-invalid');
                    } else {
                        $month.removeClass('is-invalid');
                    }

                    if ( day > 31 || day < 1) {
                        $day.addClass('is-invalid');
                    } else {
                        $day.removeClass('is-invalid');
                    }

                    let age = new Date(new Date(dateFrom) - new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)).getFullYear() - 1970;

                    if ( age >= 18 ) {
                        _adults++;
                    } else {
                        _childrenAges.push(String(age));
                    }
                }

                guestInfo[i] = {
                    gender: $guestsRow.find("[name='gender" + i + "']").val(),
                    firstName: $guestsRow.find("input[name='guestFirstName" + i + "']").val(),
                    lastName: $guestsRow.find("input[name='guestLastName" + i + "']").val(),
                    day: day,
                    month: month,
                    year: year
                };
            });

            if ($('.guests').find('.is-invalid').length) {
                $('button[type="submit"]').attr('disabled', 'disabled');
                return;
            } else {
                $('button[type="submit"]').removeAttr('disabled');
            }

            _childrenAges.sort((a,b) => a < b ? 1 : -1);
            // continue only if all guests are populated
            if ( (adults + childrenAges.length) == (_adults + _childrenAges.length)) {
                // AND different from initial guests
                if ( adults != _adults || childrenAges.join(',') != _childrenAges.join(',') ) {
                    let newGuests = `${_adults},${_childrenAges.length}${_childrenAges.length ? ',' + _childrenAges.join(',') : ''}`;
                    let params = booking.recalculateParams || functions.getUrlData(false);
                    params.cart_data = JSON.parse(params.cart_data);
                    params.cart_data[calcId-1].guests = newGuests;
                    if (params.cart_data[calcId-1].optionRefId) {
                        params.cart_data[calcId-1].optionRefId = null;
                    }
                    params.cart_data = JSON.stringify(params.cart_data);
                    params.language = functions.getLang();
                    params.partnerCode = $("[name='partnerCode']").val();
                    booking.recalculateParams = params;
                    $('button[type="submit"]').attr('disabled', 'disabled');
                    $.get('/services/booking_form_cart/', $.param(booking.recalculateParams)).then(response => {
                        response = JSON.parse(response);
                        if (response.status) {
                            $('.cart-booking').replaceWith(response.html);
                            booking.prepareForBooking();
                            window.observer.observe();
                            cart_data[calcId-1].guests = newGuests;
                            confirm('Zbog promena u godinama gostiju došlo je do novog obračuna.\nProverite pre nego nastavite.');

                            if (booking.calc.length) {
                                $('button[type="submit"]').removeAttr('disabled');
                            }

                            let $guestsRow = $('[data-guests-parentid="'+calcId+'"]');
                            $guestsRow.find('[data-guests]').map((i, elem) => {
                                $guestsRow.find("[name='gender" + i + "']").val(guestInfo[i].gender);
                                $guestsRow.find("input[name='guestFirstName" + i + "']").val(guestInfo[i].firstName);
                                $guestsRow.find("input[name='guestLastName" + i + "']").val(guestInfo[i].lastName);
                                $guestsRow.find("input[name='birthDateYear" + i + "']").val(guestInfo[i].year);
                                $guestsRow.find("input[name='birthDateMonth" + i + "']").val(guestInfo[i].month);
                                $guestsRow.find("input[name='birthDateDay" + i + "']").val(guestInfo[i].day);
                            });
                        }
                    });
                }
            }
        });
        
    },
    selectionCalculate($target) {
        const value = +$target.val();
        let dataItem = null;
        let calc = null;
        const data = $target.attr('data-data') ? JSON.parse($target.attr('data-data')) : [];

        if(data) {
            dataItem = data.filter(item => item.id == value )[0];
            calc = dataItem.calc;

            let dataIds = [];
            data.forEach(dataItem => {
                dataIds.push(dataItem.itemUniqueId);
            });
            booking.calc = booking.calc.filter(calcItem => {
                return ! dataIds.includes(calcItem.id);
            });
        }

        $target.attr('data-calc', calc);

        if(calc) {
            let item = JSON.parse(calc);
            item.inCalc = item.isOptional ? 0 : 1;

            $target.attr('data-id', item.id);

            booking.calc.push(item);

        }

        booking.calculate($target);
    },
    getGuestsData() {
        let guestsData = functions.getCookie('guestsData');
        guestsData = guestsData ? JSON.parse(guestsData) : {};

        for (const [index, guestData] of Object.entries(guestsData)) {
            const calcId = +index + 1;

            for (const [key, value] of Object.entries(guestData)) {
                $('[name="' + key + '"][data-calcId="' + calcId + '"]').val(value).trigger('change');
            }
        }
    },
    checkPaymentType() {
        // BOOKING PAYMENT TYPE CHECKBOX
        if($('[name="paymentType"]').length) {
            checkPaymentType();
            $('[name="paymentType"]').on('change', e => {
                checkPaymentType();
            });

            function checkPaymentType() {
                $('[name="paymentType"]').each((index, item) => {
                    const $item = $(item);
                    const id = $item.attr('id');
                    $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                });
            }
        }
    },
    prepareForBooking() {

        booking.calc = [];

        $("*[data-calc]").each(function (index) {
            let item = JSON.parse($(this).attr('data-calc'));
            item.inCalc = item.isOptional ? 0 : 1;
            booking.calc.push(item);
        });

        // calc items by unique itemId
        /*booking.calc = booking.calc.filter((value, index, self) => {
            return self.findIndex(v => v.id === value.id) === index;
        });*/

        if ( ! booking.calc.length) {
            return;
        }

        this.total();
    },
    itemTotal(item) {
        let itemTotal = 0.00;

        if (item.paymentTypeId.key) {

            if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                itemTotal = +item.quantity * +item.price;
            } else {
                itemTotal = +item.price;
            }
        } else {
            itemTotal = +item.quantity * +item.price;
        }

        return itemTotal;
    },
    total() {
        booking.totalAmount = 0.00;
        let cartItemsCalc = [];

        $.each(booking.calc, function (key, calc) {
            if (!calc.onSpot && calc.inCalc) {

                let totalAmount = booking.itemTotal(calc);

                if (! cartItemsCalc[calc.calcId]) {
                    cartItemsCalc[calc.calcId] = [];
                }

                cartItemsCalc[calc.calcId].push({totalAmount : totalAmount});

                booking.totalAmount += totalAmount;
            }
        });

        Object.keys(cartItemsCalc).forEach(key => {

            let items = cartItemsCalc[key];
            let $calc = $('.calc-' + key);
            let cartItemTotal = 0;

            $.each(items, function (key2, item) {
                cartItemTotal += item.totalAmount;
            });

            const $cartItemTotal = $calc.find('.cart-item-total');
            const currencySymbol = $cartItemTotal.attr('data-currencySymbol');
            $cartItemTotal.html(currencySymbol + ' ' + functions.formatMoney(cartItemTotal, 2, ',', '.'));
        });

        $('.cart-total-amount').html(functions.formatMoney(booking.totalAmount, 2, ',', '.'));
        
        const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
        const advance = booking.totalAmount * (advancePaymentPercent / 100);
        const rest = booking.totalAmount - advance;

        $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
        $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));
    },
    calculate($elem) {
        let $calcItem = $elem.closest('.calc-item');
        
        let $checkbox = $calcItem.find('input[type="checkbox"]');
        let checked = $checkbox.is(':checked') ? 1 : 0;
        let id = $checkbox.attr('id');
        id = id ? id.split('-')[0] : id;
        let calcData = $calcItem.attr('data-calc') ? JSON.parse($calcItem.attr('data-calc')) : null;

        let $quantity = $calcItem.find('select.quantity:visible');
        let quantity = null;

        if ($quantity.length) {
            quantity = +$quantity.val();
        }
        // debugger;
        $.each(booking.calc, function (key, calc) {
            //if (calc.id == id) {
            if (calcData && calc.id == id && calcData.calcId == calc.calcId) {

                if (quantity == null) {
                    quantity = booking.calc[key].quantity;
                }

                booking.calc[key].inCalc = checked;
                booking.calc[key].quantity = (quantity || 0);
                booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                let $itemTotalAmount = $calcItem.find('.item-total-amount');
                let currencySymbol = $itemTotalAmount.attr('data-currencysymbol');

                let itemTotalHTML = booking.calc[key].quantity > 0 
                    ? currencySymbol + ' ' + functions.formatMoney(booking.calc[key].total, 2, ',', '.') 
                    : $itemTotalAmount.attr('data-currencySymbol') + ' ' + $itemTotalAmount.attr('data-price');

                $itemTotalAmount.html(itemTotalHTML);

                const $itemPaymentType = $itemTotalAmount.siblings('.item-payment-type');
                let itemPaymentTypeHTML = booking.calc[key].quantity <= 1 ? $itemPaymentType.attr('data-paymentType') : '';
                $itemPaymentType.html(itemPaymentTypeHTML);
            }
        });

        booking.total();
    },
    submit() {
        let totalGuestData = [];

        $.each(booking.calc, function(key, item) {
            if ( ! item.inCalc) {
                delete booking.calc[key];
            } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                let $guestsPerProduct = $("[data-guests-parentId='" + item.calcId + "']");
                let guests = [];

                if ($guestsPerProduct.length) {
                    $guestsPerProduct.find('[data-guests]').each(function (index) {
                        let g = +$(this).data('guests');

                        let guestData = {
                            firstName : $(this).find("input[name='guestFirstName" + g + "']").val(),
                            lastName : $(this).find("input[name='guestLastName" + g + "']").val(),
                            birthDate : $(this).find("*[name='birthDateYear" + g + "']").length ? $(this).find("*[name='birthDateYear" + g + "']").val() + '-' + $(this).find("*[name='birthDateMonth" + g + "']").val() + '-' + $(this).find("*[name='birthDateDay" + g + "']").val() : null,
                            gender : $(this).find("*[name='gender" + g + "']").length ? $(this).find("*[name='gender" + g + "']").val() : null,
                        }

                        guests[index] = guestData;

                        let guestExists = totalGuestData.find(guest => JSON.stringify(guest) === JSON.stringify(guestData));
                        ! guestExists && totalGuestData.push(guestData);
                    });
                    if (booking.calc[key]) booking.calc[key].guestsData = guests;
                }
                
            }

            // IS SUPPLEMENT FOR DEPARTURE
            if (item.itemDefinitionId.id == 160) {

                let transferItem = booking.calc.find(calcItem => {
                    return calcItem && calcItem.itemDefinitionId.id == 35;
                });

                if (transferItem && item.data) {
                    transferItem.data = item.data;
                    transferItem.placeFromId = item.data.placeFromId.placeId;
                    transferItem.placeReturnId = item.data.placeReturnId?.placeId ?? transferItem.placeFromId;
    
                    let calcItemTitle = item.itemDefinitionId.text + ' - ' + item.data.placeFromId.placeName;
    
                    item.itemTitle = {
                        name_hr: calcItemTitle,
                        name_sr: calcItemTitle,
                    };
                }
            }
        });

        booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val() ? booking.$payment.find("[name='paymentType']:checked").val() : 'bankTransfer';
        if (booking.params.paymentType == 'creditCard') booking.params.platformType = 'CorvusPay';
        
        let calculation = booking.calc.filter(item => item);
        booking.params.calc = JSON.stringify(calculation);
        booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

        $.each(booking.params, function (key, param) {
            $('<input>').attr({
                type: 'hidden',
                name: key,
                value: param
            }).appendTo(booking.$form);
        });
    },
};